import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=8c56617a&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=8c56617a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c56617a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c56617a')) {
      api.createRecord('8c56617a', component.options)
    } else {
      api.reload('8c56617a', component.options)
    }
    module.hot.accept("./PurchaseOrder.vue?vue&type=template&id=8c56617a&scoped=true", function () {
      api.rerender('8c56617a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/PurchaseOrder.vue"
export default component.exports